document.addEventListener("DOMContentLoaded", () => {
  // console.log("Script loaded")
  const paintBtn = document.getElementById('loadPaintAreaButton');
  const paintOverlay = document.getElementById('paintAreaOverlay');
  const closeBtn = document.getElementById('resetButton');
  const colorInput = document.getElementById('color-number');
  const colorLabel = document.querySelector('label[for="color-number"]');
  const submitButton = document.querySelector('.product-form__submit');

  const testChecker = document.getElementById('test-checker');
  const loadingSvg = document.getElementById('loading-svg');
  const backgroundSample = document.querySelector('.sample-link');
  const backgroundElement = document.getElementById('background-c');
  const scColorName = document.getElementById('scColorName');
  const scColorCode = document.getElementById('scColorCode');

  const dialogSC = document.getElementById('selectedColorBlock');
  const closeScAreaBtn = document.getElementById('closeScAreaBtn');
  const dialogContent = document.querySelector('.selected-color-content');
  
  function openSelectedColorDialog() {
    if (!dialogSC || !dialogContent  || !scColorName || !scColorCode) return;
  
    const currentValue = colorInput ? colorInput.value.trim() : '';
    const [cName, cCode] = currentValue.split(/\s+(?=\d+$)/);
    scColorName.textContent = cName || 'Pure White';
    scColorCode.textContent = cCode || '0001';
    
    if (dialogContent) {
      dialogContent.style.setProperty(
        'background-color',
        testChecker.style.backgroundColor || '#ffffff',
        'important'
      );
    }
    dialogSC.style.display = 'flex';
  }

  
  if (paintOverlay) paintOverlay.style.display = 'none';

  if (paintBtn && paintOverlay) {
    paintBtn.addEventListener('click', (e) => {
      e.preventDefault();
      // console.log("Opened")
      paintOverlay.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    });
  }

  document.addEventListener('showPaintArea', () => {
    if (paintOverlay) {
      paintOverlay.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }
  });

  if (closeBtn && paintOverlay) {
    closeBtn.addEventListener('click', () => {
      if (colorInput) colorInput.value = '';
      if (testChecker) testChecker.innerText = '';
      if (dialogContent) dialogContent.style.backgroundColor = '#ffffff';
      if (testChecker) testChecker.style.backgroundColor = 'white';
      if (scColorName) scColorName.textContent = 'Pure White';
      if (scColorCode) scColorCode.textContent = '1';
      if (submitButton) submitButton.disabled = false;
      if (backgroundSample) backgroundSample.style.backgroundColor = '#f2f2f2';
      if (backgroundElement) backgroundElement.style.backgroundColor = '#f5f0eb';

      // setBorderColor('purple');
      paintOverlay.style.display = 'none';
      document.body.style.overflow = '';
    });
  }

  window.addEventListener("message", (event) => {
    // console.log("here")
    if (event.origin !== 'https://colors.kompozitusa.com') return;
    const data = event.data;
    
    if (data.action === 'closeApi' && paintOverlay) {
      // console.log("Pressed")
      paintOverlay.style.display = 'none';
      document.body.style.overflow = '';
    }

    if (data.message) {
      if (colorInput) colorInput.value = data.message;
      if (scColorName) scColorName.textContent = data.colorName;
      if (scColorCode) scColorCode.textContent = data.colorCode;

      // setBorderColor('purple');

      if (testChecker) {
        testChecker.innerText = '';
        testChecker.style.backgroundColor = data.color || 'white';
      }
      if (dialogContent) {
        dialogContent.style.setProperty('background-color', data.color || '#ffffff', 'important');
      }


      if (backgroundSample) backgroundSample.style.backgroundColor = data.color || '#f2f2f2';

      if (submitButton) submitButton.disabled = false;
      if (loadingSvg) loadingSvg.style.display = 'none';
      if (paintOverlay) {
        paintOverlay.style.display = 'none';
        document.body.style.overflow = '';
      }
    }
  });

  if (colorInput && colorLabel) {
    const span = document.createElement('span');
    span.style.marginLeft = '10px';
    span.style.display = 'none';
    colorLabel.appendChild(span);

    colorInput.addEventListener('input', (e) => {
      const length = e.target.value.length;
      span.textContent = `${length} | 35`;
      span.style.display = length > 0 ? 'inline' : 'none';
    });
  }

  if (testChecker && dialogSC) {
    testChecker.addEventListener('click', openSelectedColorDialog);
  }

  if (dialogSC) {
    dialogSC.addEventListener('click', (e) => {
      if (e.target === dialogSC) {
        dialogSC.style.display = 'none';
      }
    });
  }

  if (closeScAreaBtn && dialogSC) {
    closeScAreaBtn.addEventListener('click', () => {
      dialogSC.style.display = 'none';
    });
  }

  function setBorderColor(color) {
    if (!colorInput || !testChecker) return;

    colorInput.style.setProperty('border-color', color, 'important');
    if (color === 'red') {
      testChecker.style.border = 'none';
    } else {
      // testChecker.style.setProperty('border', '1px solid purple', 'important');
    }
  }
});